import { SchemaRecord } from "../SchemaRecord.js";

export class DeviceLinkStatusParams extends SchemaRecord {
  static type = "chat.params.device_link_status";
  static schema = {};
}
